import { render, staticRenderFns } from "./rczp.vue?vue&type=template&id=497477fb&"
import script from "./rczp.vue?vue&type=script&lang=js&"
export * from "./rczp.vue?vue&type=script&lang=js&"
import style0 from "./rczp.vue?vue&type=style&index=0&id=497477fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports